import type { RepositoryArtifactKind } from "./types";

function lower(path: string): string {
  return path.toLowerCase();
}

export function classifyRepositoryPath(path: string): RepositoryArtifactKind {
  const value = lower(path);

  if (value.includes("/specs/") || value.startsWith("specs/")) {
    return "spec";
  }

  if (
    value.includes("/docs/") ||
    value.startsWith("docs/") ||
    /(^|\/)readme(\.|$)/i.test(path)
  ) {
    return "documentation";
  }

  if (value.includes(".github/workflows/") || value.includes("/workflows/")) {
    return "workflow";
  }

  if (
    value.includes("/migrations/") ||
    value.startsWith("supabase/migrations/")
  ) {
    return "migration";
  }

  if (
    /(^|\/)(package\.json|package-lock\.json|pnpm-lock\.yaml|yarn\.lock|requirements\.txt|pyproject\.toml|cargo\.toml|go\.mod)$/i.test(
      path,
    )
  ) {
    return "dependency";
  }

  if (
    /(^|\/)(wrangler\.jsonc?|dockerfile|docker-compose\.ya?ml|vercel\.json|netlify\.toml)$/i.test(
      path,
    )
  ) {
    return "infrastructure";
  }

  if (
    /(^|\/)(tsconfig[^/]*\.json|vite\.config\.[^/]+|vitest\.config\.[^/]+|eslint\.config\.[^/]+|\.env\.example)$/i.test(
      path,
    )
  ) {
    return "configuration";
  }

  if (/\.(test|spec)\.(ts|tsx|js|jsx|mjs|cjs)$/i.test(path)) {
    return "test";
  }

  if (
    /\.(ts|tsx|js|jsx|mjs|cjs|py|rs|go|java|kt|swift|sql|css|scss|html)$/i.test(
      path,
    )
  ) {
    return "source";
  }

  if (/\.(png|jpg|jpeg|gif|svg|webp|ico|woff2?|ttf)$/i.test(path)) {
    return "asset";
  }

  return "unknown";
}
